import i18n from 'i18n-js';
import * as types from './types';
import { getErrorMessage } from 'utils';
import { uiActions } from 'state/modules/UI';
import * as configActions from 'services/api/config';

import { updateAbilitiesConfig } from 'config/ability';

const fetchConfigRequest = () => ({
  type: types.FETCH_CONFIG_REQUEST,
});

const fetchConfigSuccess = (payload) => ({
  type: types.FETCH_CONFIG_SUCCESS,
  payload,
});

const fetchConfigFailed = () => ({
  type: types.FETCH_CONFIG_FAILED,
});

export const fetchConfig = () => {
  return async (dispatch) => {
    dispatch(fetchConfigRequest());

    const response = await configActions.fetchConfig();

    if (response.ok) {
      updateAbilitiesConfig(response.data.core);
      sessionStorage.setItem(
        'reservation_engine',
        response.data.core?.organization?.engine || 'V1'
      );
      return dispatch(fetchConfigSuccess(response.data));
    }

    dispatch(fetchConfigFailed());
  };
};

const updateConfigurationPreferencesRequest = ({ payload }) => ({
  type: types.UPDATE_CONFIGURATION_PREFERENCES,
  payload,
});

export const updateConfigurationPreferences = (key, data) => {
  return updateConfigurationPreferencesRequest({
    payload: { [key]: data },
  });
};

// UPDATE CONFIGURATIONS CORE/INTEGRATIONS
const fetchUpdateConfigurationsRequest = () => ({
  type: types.FETCH_UPDATE_CONFIG_REQUEST,
});

const fetchUpdateConfigurationsSuccess = (payload) => ({
  type: types.FETCH_UPDATE_CONFIG_SUCCESS,
  payload,
});

const fetchUpdateConfigurationsFailed = () => ({
  type: types.FETCH_UPDATE_CONFIG_FAILED,
});

export const fetchUpdateConfigurations = (payload) => {
  return async (dispatch) => {
    dispatch(fetchUpdateConfigurationsRequest());

    const response = await configActions.fetchUpdateConfigurations(payload);

    if (response.ok) {
      updateAbilitiesConfig(response.data.core);
      dispatch(fetchUpdateConfigurationsSuccess(response.data));
      return dispatch(
        uiActions.handleShowSnackbar({
          type: 'success',
          message: i18n.t('configuration.updated_success'),
        })
      );
    }

    const error = getErrorMessage(response.data);

    dispatch(
      uiActions.handleShowSnackbar({
        type: 'error',
        message: error,
      })
    );
    dispatch(fetchUpdateConfigurationsFailed());
  };
};
